/**
 * O anel dos envios: cheio pelo andamento (app) ou esvaziando com a espera dos 60 s (WhatsApp).
 * Com "reduzir movimento", quem chama mostra o número no lugar do anel em movimento.
 */
export function OutreachRing({
  value,
  size = 26,
  stroke = 3,
  tone = 'brand',
}: {
  /** De 0 a 1. */
  value: number;
  size?: number;
  stroke?: number;
  tone?: 'brand' | 'wa' | 'ink';
}) {
  const radius = (size - stroke) / 2;
  const length = 2 * Math.PI * radius;
  const clamped = Math.min(1, Math.max(0, value));
  return (
    <svg
      className={`or-ring ${tone}`}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      aria-hidden="true"
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.22"
        strokeWidth={stroke}
      />
      <circle
        className="or-ring-v"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={length}
        strokeDashoffset={length * (1 - clamped)}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
}
